import { render, staticRenderFns } from "./Periodicity.vue?vue&type=template&id=c0ad081e&scoped=true&"
import script from "./Periodicity.vue?vue&type=script&lang=js&"
export * from "./Periodicity.vue?vue&type=script&lang=js&"
import style0 from "./Periodicity.vue?vue&type=style&index=0&id=c0ad081e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad081e",
  null
  
)

export default component.exports